import _isEmpty from 'lodash/isEmpty';
import React from 'react';

import { CommentListType } from '@/apis/comment/types';

import NoReply from './NoReply';
import Reply from './Reply';

type Props = { data: CommentListType | undefined };

/* 댓글 목록 아이템 */
export default function ReplyList({ data }: Props) {
  if (!data || _isEmpty(data?.results)) {
    return <NoReply />;
  }

  return (
    <div className="border-t border-solid border-apps-coreProductDivider">
      {data.results.map((comment) => (
        <Reply key={comment.idx} data={comment} />
      ))}
    </div>
  );
}
